import * as jQuery from 'jquery';
var $ = jQuery;
export function horizontalStatsWidgetScripts() {
    $(document).ready(function () {
        'use strict';
        // Initialize horizontal stats functionality
        function initHorizontalStats() {
            var statsWidget = document.querySelector('.horizontal-stats-widget');
            if (!statsWidget)
                return;
            // Set up intersection observer for scroll-triggered animation
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        animateNumbers(entry.target);
                        observer.unobserve(entry.target); // Only animate once
                    }
                });
            }, {
                threshold: 0.5, // Trigger when 50% of the widget is visible
                rootMargin: '0px 0px -100px 0px' // Start animation slightly before fully in view
            });
            observer.observe(statsWidget);
        }
        // Animate numbers from 0 to target value
        function animateNumbers(widget) {
            var numberElements = widget.querySelectorAll('.stat-number-value');
            numberElements.forEach(function (element) {
                var rawTarget = (element.getAttribute('data-target') || '0').trim();
                var targetValue = parseFloat(rawTarget);
                var decimalPart = rawTarget.includes('.') ? rawTarget.split('.')[1] || '' : '';
                var decimalPlaces = decimalPart.length;
                var precisionFactor = Math.pow(10, decimalPlaces);
                var formatValue = function (value) {
                    if (decimalPlaces > 0) {
                        return value.toFixed(decimalPlaces);
                    }
                    return Math.floor(value).toString();
                };
                if (!Number.isFinite(targetValue)) {
                    element.textContent = '0';
                    return;
                }
                var duration = 2000; // 2 seconds
                var startTime = performance.now();
                function updateNumber(currentTime) {
                    var elapsed = currentTime - startTime;
                    var progress = Math.min(elapsed / duration, 1);
                    // Easing function for more linear animation
                    var easeOutQuad = 1 - Math.pow(1 - progress, 2);
                    var currentValue = Math.floor(targetValue * easeOutQuad * precisionFactor) / precisionFactor;
                    element.textContent = formatValue(currentValue);
                    if (progress < 1) {
                        requestAnimationFrame(updateNumber);
                    }
                    else {
                        element.textContent = formatValue(targetValue); // Ensure final value is exact
                    }
                }
                requestAnimationFrame(updateNumber);
            });
        }
        // Initialize when DOM is ready
        initHorizontalStats();
    });
}
